import {Component, OnInit, HostListener} from '@angular/core';
import {faArrowUp} from "@fortawesome/free-solid-svg-icons";

@Component({
    standalone: false,
    selector: 'iw-shop-core-scroll-to-top',
    templateUrl: './scroll-to-top.component.html',
    styleUrls: ['./scroll-to-top.component.scss']
})

export class ScrollToTopComponent implements OnInit {

    showScroll: boolean = false;
    showScrollHeight = 200;
    hideScrollHeight = 200;

    constructor() {
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        if (
            (
                document.documentElement.scrollTop ||
                document.body.scrollTop
            ) > this.showScrollHeight
        ) {
            this.showScroll = true;
        } else if (this.showScroll &&
            (
                document.documentElement.scrollTop ||
                document.body.scrollTop) < this.hideScrollHeight
        ) {
            this.showScroll = false;
        }
    }

    ngOnInit() {
    }

    scrollToTop() {
        window.scroll(0, 0);
    }

    protected readonly faArrowUp = faArrowUp;
}
